// extracted by mini-css-extract-plugin
export default {"character_type_menu_wrapper":"aigeneratepanel_character_type_menu_wrapper__5RZaN"};